import { AppConfig } from '@digilize/shared/definitions/src';

export const appConfig: AppConfig = {
  /* PAUL-3246 has not rolled this app over yet — `config` with the historical minute keeps
     today's behaviour until its backend is checked for JWT access tokens. */
  tokenExpiration: { source: 'config', minutes: 1 },
  app: 'survey-tool-client',
  appTitle: 'Survey Today',
  email: '',
  gtm: '',
  localStorageAuthPrefix: 'suc-',
  logo: {
    light: '/logo/logo-light-su.svg',
    dark: '/logo/logo-dark-su.svg',
    mark: '/logo/logo-mark-su.svg',
  },
  language: {
    defaultLanguage: 'en',
    languages: [
      { code: 'nl', iconFlagPath: 'assets/flags/netherlands.png' },
      { code: 'en', iconFlagPath: 'assets/flags/united-kingdom.png' },
      { code: 'es', iconFlagPath: 'assets/flags/spain.svg' },
    ],
  },
};
